import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";
import { buildUrl } from "../../../helper/utils";

const LeadManagementApi = {
  getCustomerData: (payload) => {
    const { mobile } = payload;
    const url = `customer?mobile=${mobile}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  getCategoryBrandData: (payload) => {
    const url = `lead/category`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  getReasons: (payload) => {
    const url = `lead/reason`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  getDownloadData: (payload) => {
    const { silentLoader, ...params } = payload;
    const url = buildUrl("lead/all/download", params);
    return request({
      method: HTTP_METHOD.GET,
      url,
            showGlobalLoader: false,
    });
  },
  getViewLeadsData: (payload) => {
    const { silentLoader, ...params } = payload;
    const url = buildUrl("lead/all", params);

    return request({
      method: HTTP_METHOD.GET,
      url,
      showGlobalLoader: !silentLoader,
    });
  },
  createLead: (payload) => {
    const url = `lead`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  updateLead: (payload) => {
    const { id } = payload;
    const url = `lead/${id}`;
    return request({
      method: HTTP_METHOD.PUT,
      url,
      data: payload,
    });
  },
  getAttributes: () => {
    const url = `lead/attributes-filters`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  getStatus: () => {
    const url = `lead/status`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
};

export default LeadManagementApi;














